export const thfPageChangePasswordLiterals = {
  en: <any> {
    backButton: 'Back',
    confirmPassword: 'Confirm password',
    createNewPassword: 'Create new password',
    createNewPasswordPhrase: 'Protect your account with a personal password created by you',
    currentPassword: 'Current password',
    enterSystemButton: 'Enter the system',
    forgotPassword: 'Forgot your password?',
    newPassword: 'New password',
    passwordSuccessfullyCreated: 'Password successfully created!',
    passwordSuccessfullyUpdated: 'Password successfully updated!',
    requirements: 'Password requirements',
    safetyTips: 'Safety tips!',
    safetyTipsFirst: 'is used in other accounts;',
    safetyTipsPhrase: 'Avoid a password that:',
    safetyTipsSecond: 'has personal information like your name, nickname or family names;',
    safetyTipsThird: 'that uses obvious sequences like "123" or obvious words like "password";',
    saveButton: 'Save',
  },
  es: <any> {
    backButton: 'Volver',
    confirmPassword: 'Confirmar seÃ±a',
    createNewPassword: 'Crear nueva contraseÃ±a',
    createNewPasswordPhrase: 'Proteger su cuenta con una contraseÃ±a personal creada por usted',
    currentPassword: 'ContraseÃ±a actual',
    enterSystemButton: 'Entrar en el sistema',
    forgotPassword: 'Â¿Olvidaste tu contraseÃ±a?',
    newPassword: 'Nueva contraseÃ±a',
    passwordSuccessfullyCreated: 'ContraseÃ±a creada correctamente!',
    passwordSuccessfullyUpdated: 'ContraseÃ±a correctamente actualizada!',
    requirements: 'Requisitos de contraseÃ±a',
    safetyTips: 'Consejos de seguridad!',
    safetyTipsFirst: 'se utilice en otras cuentas;',
    safetyTipsPhrase: 'Evite una contraseÃ±a que:',
    safetyTipsSecond: 'utiliza informaciÃ³n personal como su nombre, apellido o nombre de familia;',
    safetyTipsThird: 'utilice secuencias muy obvias como "1234" o "abcd" o palabras obvias como "contraseÃ±a";',
    saveButton: 'Guardar',
  },
  pt: <any> {
    backButton: 'Voltar',
    confirmPassword: 'Confirmar senha',
    createNewPassword: 'Criar nova senha',
    createNewPasswordPhrase: 'Proteja sua conta com uma senha pessoal criada por vocÃª',
    currentPassword: 'Senha atual',
    enterSystemButton: 'Entrar no sistema',
    forgotPassword: 'Esqueceu sua senha?',
    newPassword: 'Nova senha',
    passwordSuccessfullyCreated: 'Senha criada com sucesso!',
    passwordSuccessfullyUpdated: 'Senha alterada com sucesso!',
    requirements: 'Requisitos de senha',
    safetyTips: 'Dicas de seguranÃ§a!',
    safetyTipsFirst: 'seja usada em outras contas;',
    safetyTipsPhrase: 'Evite uma senha que:',
    safetyTipsSecond: 'usa informaÃ§Ãµes pessoais como seu nome, apelido ou nome de familiares;',
    safetyTipsThird: 'use sequÃªncias muito Ã³bvias como "1234" ou "abcd" ou palavras Ã³bvias como âsenhaâ;',
    saveButton: 'Salvar',
  }
};
